import React from 'react';
import useFailureReasons from '../../pages/trip-request/screen/use-failure-reasons';
import FailureReasonsSummaryView from './failure-reasons-summary-view';

type FailureReasonsSummaryContainerProps = {
  tripRequestId: string;
  isScreened: boolean;
};

const FailureReasonsSummaryContainer = ({
  tripRequestId,
  isScreened,
}: FailureReasonsSummaryContainerProps) => {
  const {
    canEdit,
    failureReasons,
    isLoading,
    isSaving,
    passedReasons,
    screeningCriteriaMap,
    onAddFailureReasons,
    onRemoveAllFailureReasons,
    onRemoveFailureReason,
  } = useFailureReasons(tripRequestId, isScreened);

  return (
    <FailureReasonsSummaryView
      canEdit={canEdit}
      isLoading={isLoading}
      isSaving={isSaving}
      passedReasons={passedReasons}
      isScreened={isScreened}
      reasons={failureReasons}
      screeningCriteriaMap={screeningCriteriaMap}
      onAddFailureReasons={onAddFailureReasons}
      onRemoveAllFailureReasons={onRemoveAllFailureReasons}
      onRemoveFailureReason={onRemoveFailureReason}
    />
  );
};

export default FailureReasonsSummaryContainer;
